<div class="row">
  <div class="col">
    <h3>{{ config.title }}</h3>
  </div>
  <div class="col text-right" *ngIf="config.hidePost == null || config.hidePost == false">
    <button class="btn btn-sm btn-primary" id="btnNewAction" (click)="openModalNuevaAccion()"><i class="fa fa-plus"></i>
      Nuevo</button>
  </div>
</div>
<hr>
<p *ngIf="config.collection.length == 0">No existen elementos para mostrar...</p>
<table *ngIf="config.collection.length > 0" class="table table-bordered table-striped mt-10 text-center">
  <thead>
    <tr>
      <th *ngFor="let obj of config.model">{{ setLabel(obj) }}</th>
      <th style="width: 80px;">Editar</th>
      <th *ngIf="config.hideDelete == null || config.hideDelete == false" style="width: 80px;">Eliminar</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of config.collection">
      <td *ngFor="let obj of config.model"
        [innerHTML]="obj.customCell != null ? obj.customCell(item[obj.key], this) : item[obj.key]">
      </td>
      <td>
        <button class="btn btn-sm btn-primary rounded-circle" (click)="edit(item)">
          <i class="fa fa-pencil"></i></button>
      </td>
      <td *ngIf="config.hideDelete == null || config.hideDelete == false">
        <button class="btn btn-sm btn-danger rounded-circle" (click)="delete(item)">
          <i class="fa fa-trash"></i></button>
      </td>
    </tr>
  </tbody>
</table>

<div class="modal fade" id="modalNuevo" tabindex="-1" role="dialog" aria-labelledby="modalNuevoLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form (submit)="formNew($event)" ngNativeValidate>
        <div class="modal-header">
          <h5 class="modal-title" id="modalNuevoLabel">Nuevo elemento</h5>
          <button type="button" class="close" (click)="closeModal('#modalNuevo')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row" *ngFor="let obj of filter(config.model, 'isInput')">
            <div class="col">
              <label for="">{{ setLabel(obj) }}</label>
              <textarea rows="3" *ngIf="obj.isTextArea" class="form-control" [required]="obj.isRequired"
                name="{{ config.crudId }}-new-{{ obj.key }}" id="{{ config.crudId }}-new-{{ obj.key }}"></textarea>
              <input *ngIf="!obj.isTextArea" class="form-control" [type]="obj.inputType" [required]="obj.isRequired"
                name="{{ config.crudId }}-new-{{ obj.key }}" id="{{ config.crudId }}-new-{{ obj.key }}"
                value="{{ config.crudId }}">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal('#modalNuevo')"><i
              class="fas fa-ban"></i>
            Cerrar</button>
          <button type="submit" class="btn btn-sm btn-primary"><i class="fa fa-save"></i> Guardar</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="modalEditar" tabindex="-1" role="dialog" aria-labelledby="modalEditarLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form (submit)="formEdit($event)" ngNativeValidate>
        <div class="modal-header">
          <h5 class="modal-title" id="modalEditarLabel">Editar elemento</h5>
          <button type="button" class="close" (click)="closeModal('#modalEditar')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row" *ngFor="let obj of filter(config.model, 'isInput')">
            <div class="col">
              <label for="">{{ setLabel(obj) }}</label>
              <textarea rows="3" *ngIf="obj.isTextArea" class="form-control"
                name="{{ config.crudId }}-edit-{{ obj.key }}" id="{{ config.crudId }}-edit-{{ obj.key }}"
                [required]="obj.isRequired" [(ngModel)]="config.itemEdit[obj.key]"></textarea>
              <input *ngIf="!obj.isTextArea" class="form-control" [type]="obj.inputType" [required]="obj.isRequired"
                [(ngModel)]="config.itemEdit[obj.key]" name="{{ config.crudId }}-edit-{{ obj.key }}"
                id="{{ config.crudId }}-edit-{{ obj.key }}">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal('#modalEditar')"><i
              class="fas fa-ban"></i>
            Cerrar</button>
          <button type="submit" class="btn btn-sm btn-primary"><i class="fa fa-save"></i> Guardar</button>
        </div>
      </form>
    </div>
  </div>
</div>